import BaseFactory from 'services/sports/default/base-factory';
import Simplex from './simplex';

class Factory extends BaseFactory {
    createObj(objectName, params) {
        return new Simplex(params);
    }
}

export {Factory};
